import guest from '@/router/middlewares/guest';
import auth from '@/router/middlewares/auth';
import OAuthRedirectIndex from '@/pages/auth/oauth/index.vue';

export default [
  {
    path: '/oauth/:provider',
    name: 'OAuth_Redirect',
    component: OAuthRedirectIndex,
    meta: {
      layout: 'GuestLayout'
      // middleware: [guest]
    }
  }
];
